






import ClientOnly from 'vue-client-only';
import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

type StartMode = 'focus' | 'auto' | 'none';

@Component({
	components: {
		ClientOnly,
		CaptchaClient: typeof window !== 'undefined' ? () => import('./components/CaptchaClient.vue') : {}
	}
})
export default class Captcha extends Vue {
	@Prop({
		type: String as PropType<StartMode>,
		default: 'focus'
	})
	protected startMode: StartMode = 'focus';

	protected onPuzzleSolved(solution: string): void {
		this.$emit('solved', solution);
	}

	public solve(): void {
		(this.$refs.captcha as any).solve();
	}

	public reset(): void {
		(this.$refs.captcha as any).reset();
	}
}
